import * as React from 'react'
import { useState } from 'react'
import { Route, RouteComponentProps, Switch } from 'react-router'
import Login from '../../containers/auth/Auth'
import Register from '../../containers/auth/Register'
import RecoveryPassword from '../../containers/auth/RecoveryPassword'
import NewPasswordFormikForm from '../../containers/auth/NewPasswordFormikForm'
import InvitationPaneForm from 'src/containers/auth/InvitationPaneForm'
import SignupSuccess from '../../containers/auth/SignupSuccess'

const AuthenticationPane = (props: RouteComponentProps<any>) => {
  const [notificationSystem, setNotificationSystem] = useState({})
  const NewPasswordForm = (props: any) => <NewPasswordFormikForm {...props} notificationSystem={notificationSystem} />
  return (
    <div>
      <Switch>
        <Route path={`${props.match.path}/`} component={Login} exact={true} />
        <Route path={`${props.match.path}/:role(org|rider|driver)/register`} component={Register} exact={true} />
        <Route path={`${props.match.path}/password-recovery`} exact={true} component={RecoveryPassword} />
        <Route path={`${props.match.path}/password-recovery/:token`} component={NewPasswordForm} />
        <Route path={`${props.match.path}/invitation/:userId/:organizationId/:token`} component={InvitationPaneForm} />
        <Route path={`${props.match.path}/:email/:role(org|rider|driver)/signupsuccess`} component={SignupSuccess} />
      </Switch>
    </div>
  )
}

export default AuthenticationPane



// WEBPACK FOOTER //
// ./src/components/authentication/AuthenticationPane.tsx